<template>
  <div class="regCompleteForm m-2">
    <div class="card col-md-6 col-lg-6 col-sm-12" style="margin: auto">
      <h6 class="card-header">Welcome to betway!</h6>
      <div class="card-body">
        <div class="row ty-row">
          <div class="col-xs-12">
            <h6
              data-translate-set="ThankYouDialog"
              data-translate-key="ThankYouHeader"
              data-translate-type="generic-html"
              data-translate-value-0="registering"
              data-translate-replace-value-0="true"
              data-translate-replace-value-0-key="Registering"
            >
              Thank you for Registering on
            </h6>
          </div>
          <div class="col-xs-12">
            <img src="https://cdn2.betway.co.za/Images/Betway/ty-logo.JPG" />
          </div>
          <div class="col-xs-12">
            <span
              data-translate-set="ThankYouDialog"
              data-translate-key="YourAccountNumberIs"
              ><b>Do not share your account information with others.&nbsp;</b></span>
          </div>
      </div>
      <button class="form-btn-one" onclick="location.href='https://www-betway-co-za-betwayreg.datafree.io'">Continue to Website</button>
    </div>
  </div>
</div>
</template>
  <script>
export default {
  computed: {
    getContent() {},
  },
  mounted() {},
  methods: {},
};
</script>
  <style>
.regCompleteForm {
  align-items: center;
  text-align: center;
  widows: 100%;
}
</style>
  